import React from 'react'
import SliderTestimonial from '../../component/slidercomponent/SliderTestimonial'

const HomeTestimonials = () => {
    return (
        <>

            <section className="clearfix p-t50 overlay-secondary-dark bg-primary background-blend-multiply overflow-hidden" style={{ backgroundImage: 'url(./assets/images/background/bg3.webp)', backgroundRepeat: 'no-repeat', backgroundPosition: 'right center', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="row content-wrapper style-2">
                        <div className="col-xl-6">
                            <div className="content-media">
                                <div className="dz-media">
                                    <img src="./assets/img/feedback.png" alt />
                                </div>
                                <div className="circle-wrapper skrollable skrollable-before" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)" style={{ transform: 'translateY(50px)' }}>
                                    <span className="circle1">
                                        <span />
                                        <span />
                                        <span />
                                    </span>
                                    <span className="circle2">
                                        <span />
                                        <span />
                                        <span />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-10 align-self-center m-b30">
                            <div className="section-head style-1 m-b30 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'none' }}>
                                <h2 className="title text-white m-b0">असली मरीज़, असली कहानियाँ। और हमारी उपलब्धियाँ। </h2>
                            </div>
                            <div className="swiper-btn-center-lr wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.4s', animationName: 'none' }}>
                                <div className="swiper testimonial-swiper1 swiper-initialized swiper-horizontal swiper-backface-hidden">
                                    <div className="swiper-wrapper" id="swiper-wrapper-a7101990c5cff76dd" aria-live="off" style={{ transitionDuration: '0ms', transform: 'translate3d(-1140px, 0px, 0px)', transitionDelay: '0ms' }}>
                                        <div className="swiper-slide swiper-slide-next" role="group" aria-label="2 / 3" data-swiper-slide-index={1} style={{ width: 550, marginRight: 20 }}>
                                            <div className="testimonial-1 shadow-md">
                                                <div className="dz-media">
                                                    <div className="media-inner">
                                                        <img src="./assets/img/profile.png" alt="/" />
                                                    </div>
                                                    <div className="testimonial-info">
                                                        <h5 className="testimonial-name">श्री आशीष परिहार</h5>
                                                        <span className="testimonial-position">मरीज़</span>
                                                    </div>
                                                </div>
                                                <div className="testimonial-detail">
                                                    <div className="testimonial-text">
                                                       
                                                        <p>“साफ़-सुथरी सुविधाएँ, विनम्र स्टाफ़ और बेहतरीन मेडिकल देखभाल। डॉक्टरों ने सब कुछ साफ़-साफ़ और धैर्यपूर्वक समझाया।”</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="swiper-slide swiper-slide-prev" role="group" aria-label="3 / 3" data-swiper-slide-index={2} style={{ width: 550, marginRight: 20 }}>
                                            <div className="testimonial-1 shadow-md">
                                                <div className="dz-media">
                                                    <div className="media-inner">
                                                        <img src="./assets/img/profile.png" alt="/" />

                                                    </div>
                                                    <div className="testimonial-info">
                                                        <h5 className="testimonial-name">श्री देवेश शुक्ला</h5>
                                                        <span className="testimonial-position">मरीज़</span>
                                                    </div>
                                                </div>
                                                <div className="testimonial-detail">
                                                    <div className="testimonial-text">
                                                        <p>डॉक्टर और नर्सिंग स्टाफ़ बहुत ही देखभाल करने वाले और प्रोफेशनल थे। अपने इलाज के दौरान मुझे सुरक्षित महसूस हुआ और मेरी अच्छी तरह से देखभाल की गई।</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 3" data-swiper-slide-index={0} style={{ width: 550, marginRight: 20 }}>
                                            <div className="testimonial-1 shadow-md">
                                                <div className="dz-media">
                                                    <div className="media-inner">
                                                        <img src="./assets/img/profile.png" style={{ borderRadius: "900px" }} alt="/" />
                                                    </div>
                                                    <div className="testimonial-info">
                                                        <h5 className="testimonial-name">श्री अर्जुन कुमार</h5>
                                                        <span className="testimonial-position">मरीज़</span>
                                                    </div>
                                                </div>
                                                <div className="testimonial-detail">
                                                    <div className="testimonial-text">
                                                        <p>“एडमिशन से लेकर डिस्चार्ज तक, पूरी प्रक्रिया बहुत आसानी से हुई। मैं हॉस्पिटल की टीम के समर्पण की सचमुच सराहना करता हूँ।”</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="swiper-notification" aria-live="assertive" aria-atomic="true" /></div>
                                <div className="swiper1-button-prev btn-prev" tabIndex={0} role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-a7101990c5cff76dd">
                                    <img src="./assets/images/svg/arrow-left.svg" alt />
                                </div>
                                <div className="swiper1-button-next btn-next" tabIndex={0} role="button" aria-label="Next slide" aria-controls="swiper-wrapper-a7101990c5cff76dd">
                                    <img src="./assets/images/svg/arrow-right.svg" alt />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default HomeTestimonials